import qs from 'querystring'
import { isDuApp } from '@/utils/appUtils/getDevice'
import Jockeys from '../jockey'

export function customJump(item: {
  targetUrl?: string;
  customUrl?: string;
  query?: string;
}) {
  if (typeof window === 'undefined' || !item.targetUrl ) return
  if ((window as any).editorFlag  === 'edit') return
  // 自定义跳转地址
  if (item.targetUrl === '自定义跳转') {
    if (item.customUrl) {
      (window as any).location.href = item.customUrl
    }
    return
  }
  const query = item.query ? `?${item.query}` : ''
  // const needScene = this.props.propsConfig?.needScene ?? false
  const [appRouter, h5Router] = item.targetUrl.split('******') ?? []
  if (isDuApp()) {
    Jockeys.openNativePage(appRouter, qs.parse(query.slice(1)))
    return
  }

  // if (needScene) {
  //   appRouter && (appInstall(appRouter, qs.parse(query.slice(1))))
  //   return
  // }
  h5Router && ((window as any).location.href = `${h5Router + query}`)
}

export function checkCanSkip(item: {
  targetUrl?: string;
  customUrl?: string;
}) {
  if (!item.targetUrl ) return false
  if (item.targetUrl === '自定义跳转' && !item.customUrl) {
    return false
  }
  return true
}
